
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import nineDirections from '@/api/nineDirections'
import Card from './card.vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
interface pageDataType {
  delicateList: any[]
  subject: any
  theme: string
  loading: boolean
}
export default defineComponent({
  components: { RightOutlined, Card },
  setup() {
    const route = useRoute()
    const pageData: pageDataType = reactive({
      delicateList: [],
      subject: [],
      theme: (route.query.theme || '').toString() || 'light',
      loading: false
    })
    function getSchoolHome() {
      const data: any = {}
      nineDirections.schoolHome(data).then((res: any) => {
        if (res.code === 1 && res.data) {
          pageData.delicateList = res.data.delicate || []
          pageData.subject = (res.data.subject || [])
        }
      })
      // // 调用文章课文章分页查询接口
      // nineDirections.schoolCourseArticlePage({
      //   courseNo: 'efe02f67d22e4a7c93edcc0215719507',
      //   pageNo: 1,
      //   pageSize: 10
      // }, {
      //   username: route.query.userName as string || '',
      //   token: route.query.token as string || '',
      //   appcode: 'com.rjhy.uranus',
      //   clienttype: 'pc'
      // }).then((res: any) => {
      //   console.log('schoolCourseArticlePage:', res)
      // })
      // // 调用文章详情接口
      // nineDirections.newsContent({
      //   newsId: 'a1c4ff8b75a4da3405e5db6750bc7b24',
      //   token: route.query.token as string || '',
      //   appcode: 'com.rjhy.uranus',
      //   clienttype: 'pc'
      // }, {
      // }).then((res: any) => {
      //   console.log('newsContent:', res)
      // })
    }
    // 格式化moduleItems为Card组件需要的格式
    function formatModuleItems(moduleItems: any[]) {
      if (!moduleItems) return []
      return moduleItems.map((course: any) => ({
        courseNo: course.courseNo,
        courseName: course.courseName,
        coverImage: course.courseImageUrl,
        introduction: course.courseIntro,
        lessonNo: null,
        chapterNo: null,
        subCourseNo: null,
        courseType: course.courseType
      }))
    }
    getSchoolHome()
    function jumpToCourse(p: { courseNo: string; lessonNo?: string; courseType?: number }) {
      if (!route.query.token) {
        gotoClientLogin()
        return
      }
      console.log('pcourseType',p)
      // courseType: 12 跳转视频课程详情，13 跳转文章详情
      if (p.courseType === 13) {
        router.push({
          name: 'articledetail',
          query: {
            ...route.query,
            courseNo: p.courseNo,
            from: 'excellentcourse'
          }
        })
        return
      }
      // 默认跳转视频课程详情 (courseType === 12 或其他)
      const obj: any = {
        name: 'coursedetail',
        query: {
          ...route.query,
          courseNo: p.courseNo,
          from: 'excellentcourse'
        }
      }
      if (p.lessonNo) {
        obj.query.lessonNo = p.lessonNo
      }
      router.push(obj)
    }
    function jumpToSubjectDetail(item: any) {
      router.push({
        name: 'subjectdetail',
        query: {
          ...route.query,
          subjectCode: item.schoolCourseGroupCode,
          subjectName: item.configName,
          subjectIntro: item.schoolCourseGroupIntro || ''
        }
      })
    }
    watch(
      () => route.query.theme,
      () => {
        pageData.theme = route.query.theme as string
      }
    )
    return {
      ...toRefs(pageData),
      jumpToCourse,
      jumpToSubjectDetail,
      formatModuleItems
    }
  }
})
